import * as yup from 'yup'
import { disableableProperties } from './Core.schema'

export const inputPropertiesSchema = yup
	.object({
		label: yup.string(),
		required: yup.boolean().default(false),
		autoFocus: yup.boolean().default(false),
		readOnly: yup.boolean().default(false),
		tabIndex: yup.number(),
		inputHeight: yup.number().notRequired(),
		inputHeightMobile: yup.number().notRequired(),
		inputMobileFontSize: yup.number().notRequired(),
		labelMargin: yup.number().default(14),
		labelPadding: yup.number().default(0),
		labelMobileFontSize: yup.number().notRequired(),
	})
	.concat(disableableProperties)
